import Icon from '@/components/ui/AppIcon';

const SafetyWarnings = () => {
  const warnings = [
    {
      icon: 'ExclamationTriangleIcon',
      title: 'Counterfeit Risk',
      description: 'Always verify seller authenticity and check for OEM certification. Counterfeit parts may look identical but lack quality standards.',
      severity: 'high'
    },
    {
      icon: 'ShieldCheckIcon',
      title: 'Compatibility Verification',
      description: 'Double-check part numbers match your exact vehicle year, make, and model. Even within the same model, parts may vary by trim level.',
      severity: 'medium'
    },
    {
      icon: 'UserGroupIcon',
      title: 'Seller Trustworthiness',
      description: 'Look for sellers with 98%+ positive feedback, detailed return policies, and OEM part guarantees. Avoid deals that seem too good to be true.',
      severity: 'medium'
    }
  ];

  return (
    <div className="bg-card rounded-xl shadow-elevation-md p-6 space-y-4">
      <div className="flex items-center space-x-2">
        <Icon name="ShieldExclamationIcon" size={24} className="text-warning" />
        <h3 className="font-heading text-lg font-semibold text-text-primary">
          Safety & Trust Guidelines
        </h3>
      </div>

      <div className="space-y-3">
        {warnings.map((warning, index) => (
          <div
            key={index}
            className={`rounded-lg border p-4 ${
              warning.severity === 'high' ?'border-error/30 bg-error/5' :'border-warning/30 bg-warning/5'
            }`}
          >
            <div className="flex items-start space-x-3">
              <Icon
                name={warning.icon as any}
                size={20}
                className={`flex-shrink-0 mt-0.5 ${
                  warning.severity === 'high' ? 'text-error' : 'text-warning'
                }`}
              />
              <div className="flex-1">
                <h4 className="font-heading text-sm font-semibold text-text-primary mb-1">
                  {warning.title}
                </h4>
                <p className="font-body text-xs text-text-secondary leading-relaxed">
                  {warning.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="rounded-lg bg-primary/5 border border-primary/20 p-4">
        <div className="flex items-start space-x-3">
          <Icon name="InformationCircleIcon" size={20} className="text-primary flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="font-caption text-xs font-medium text-primary mb-1">
              Recommended Practice
            </p>
            <p className="font-body text-xs text-text-secondary leading-relaxed">
              When in doubt, consult with a trusted mechanic before purchasing. They can verify part compatibility and authenticity.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SafetyWarnings;